// src/screens/UserOrderListScreen.js
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Table, Button, Badge } from 'react-bootstrap';
import { FaTimes, FaCheck, FaEye, FaShoppingBag } from 'react-icons/fa';
import Message from '../components/Message';
import Loader from '../components/Loader';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useGetMyOrdersQuery } from '../slices/ordersApiSlice';

const UserOrderListScreen = () => {
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.auth);

  const { data: orders, isLoading, error } = useGetMyOrdersQuery();

  useEffect(() => {
    if (!userInfo) {
      navigate('/login');
    }
  }, [userInfo, navigate]);

  if (isLoading) {
    return <Loader />;
  }

  if (error) {
    return (
      <Message variant='danger'>
        {error?.data?.message || error.error}
      </Message>
    );
  }

  return (
    <div className='admin-panel'>
      <div className='page-heading d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3'>
        <h1 className='mb-0'>Mes Commandes</h1>
        <Badge bg='success' className='fs-6'>
          <FaShoppingBag className='me-1' />
          {orders?.length || 0} commandes
        </Badge>
      </div>

      <Table hover responsive className='table-sm align-middle'>
        <thead>
          <tr>
            <th>ID Commande</th>
            <th>Date</th>
            <th>Total</th>
            <th>Statut Paiement</th>
            <th>Livraison</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {orders?.map((order) => (
            <tr key={order._id}>
              <td className='text-muted' style={{ fontSize: '0.8rem' }}>
                {order._id.substring(0, 10)}...
              </td>
              <td>{new Date(order.createdAt).toLocaleDateString('fr-FR')}</td>
              <td>
                <Badge bg='success'>{order.totalPrice} TND</Badge>
              </td>
              <td>
                {order.isPaid ? (
                  <Badge bg='success'>
                    <FaCheck className='me-1' /> Payé
                  </Badge>
                ) : (
                  <Badge bg='warning'>
                    <FaTimes className='me-1' /> En attente
                  </Badge>
                )}
              </td>
              <td>
                {order.isDelivered ? (
                  <Badge bg='success'>
                    <FaCheck className='me-1' /> Livré
                  </Badge>
                ) : (
                  <Badge bg='secondary'>
                    <FaTimes className='me-1' /> En cours
                  </Badge>
                )}
              </td>
              <td>
                <Link to={`/order/${order._id}`}>
                  <Button className='btn-sm btn-outline-teal' variant='outline-secondary'>
                    <FaEye className='me-1' />
                    Détails
                  </Button>
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {(!orders || orders.length === 0) && (
        <Message variant='info'>
          <FaShoppingBag className='me-2' />
          Vous n&apos;avez pas encore passé de commande.
        </Message>
      )}
    </div>
  );
};

export default UserOrderListScreen;
